module.exports = __webpack_public_path__ + "img/active_4.db780896.png";